import { rem } from "polished";
import { css } from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const baseButtonStyle = css`
  font-weight: 700;
  font-size: ${rem(15)};
  line-height: ${rem(28)};
  border-radius: ${rem(200)};
  padding: ${rem(8)} ${rem(40)};
  width: max-content;
  word-break: break-word;
  hyphens: auto;
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
  `}
`;

export const colorSet = [
  {
    title: "Light green",
    colors: [
      "#000000", // primary
      "#dae2c7", // secondary
      "#f8faf4", // background
      "#000000", // primaryFont
      "#e6eadc", // visual
      "#4a4a4a", // secondaryFont
      "#ffffff", // visuals_2
    ],
  },
  {
    title: "Solid green",
    colors: [
      "#008446", // primary
      "#b1d0b3", // secondary
      "#0d362c", // background
      "#dfeeea", // primaryFont
      "#f49608", // visual
      "#a2bdb7", // secondaryFont,
      "#ffffff", // visuals_2
    ],
  },
];

export const fonts = [
  {
    name: "Primary",
    value: "Sora",
    provider: "google",
  },
];
